<template>
    <div class="goals-chart">
        <design-2021-apprentice-radial-bar-chart-component :series="radialBarData.series"
                                                           :options="radialBarData.options">
        </design-2021-apprentice-radial-bar-chart-component>
    </div>
</template>

<script>
    export default {
        name: "design-2021-personal-goal-widget-radial-bar-chart-component",
        props: {
            personalGoalIn: Object,
        },
        computed: {
            radialBarData(){
                if(this.personalGoalIn){
                    const stats = this.personalGoalIn.getPersonalGoalTasksStatuses();
                    return {
                        percentage: stats.percentage,
                        series: [stats.percentage],
                        options: {
                            chart: {
                                id: 'personal-goal',
                                type: 'radialBar',
                            },
                            plotOptions: {
                                radialBar: {
                                    hollow: {
                                        size: '70%',
                                        margin: 0,
                                        background: "#F2FAFF"
                                    },
                                    track: {
                                        show: true,
                                        strokeWidth: '97%',
                                        opacity: 1,
                                        margin: 0,
                                        background: '#837c92',
                                        dropShadow: {
                                            enabled: true,
                                            top: 2,
                                            left: 0,
                                            blur: 4,
                                            opacity: 0.15
                                        }
                                    },
                                    dataLabels: {
                                        show: true,
                                        name: {
                                            show: true,
                                            fontSize: '16px',
                                            fontFamily: 'DM Sans',
                                            fontWeight: 500,
                                            color: '#212529',
                                            offsetY: -10
                                        },
                                        value: {
                                            show: true,
                                            fontSize: '14px',
                                            fontFamily: 'DM Sans',
                                            fontWeight: 500,
                                            color: '#212529',
                                            offsetY: -10,
                                            formatter: function (val) {
                                                return val + '%'
                                            }
                                        },
                                    },
                                },
                            },
                            fill: {
                                opacity: 1,
                                type: "solid",
                                colors: [function({ value, seriesIndex, w }) {
                                    if(value === 0) {
                                        return '#000'
                                    } else if (value > 0 && value < 25) {
                                        return '#f00'
                                    } else if (value >= 25 && value < 50) {
                                        return '#FF6F00'
                                    } else if (value >= 50 && value < 75) {
                                        return '#E7C701'
                                    } else if (value >= 75 && value < 100) {
                                        return '#b6cc05'
                                    } else if (value === 100) {
                                        return '#61CC13'
                                    }
                                }]
                            },
                            stroke: {
                                lineCap: "round"
                            },
                            labels: [''],
                        }
                    }
                }
                return {
                    series: [],
                    options: {}
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .goals-chart {
        width: 100px;
    }
</style>
